export default function Cookies({ setPage }) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-50 via-blue-50 to-white px-4 py-16">
      <div className="max-w-4xl mx-auto bg-white rounded-3xl shadow-sm p-8 md:p-12">

        <button
          onClick={() => setPage("landing")}
          className="text-sm text-indigo-600 hover:underline mb-8"
        >
          ← Volver
        </button>

        <h1 className="text-3xl font-bold mb-8">Política de Cookies</h1>

        <section className="space-y-6 text-gray-700">
          <p>
            Biajando utiliza cookies técnicas necesarias para el correcto
            funcionamiento de la web.
          </p>

          <p>
            También se emplean cookies analíticas básicas, como Google Analytics,
            con el único fin de mejorar la experiencia del usuario.
          </p>

          <p>
            No se utilizan cookies de publicidad ni seguimiento comercial.
          </p>
        </section>

      </div>
    </div>
  );
}
